import type { OrderDeliveryPreference } from '../services/api/types.gen';

/** Display labels for every order delivery preference value. */
export const ORDER_DELIVERY_LABELS: Record<OrderDeliveryPreference, string> = {
  fax: 'Fax',
  email: 'Email',
  mail: 'Mail',
  courier: 'Courier',
  other: 'Other',
  none: 'None',
  circle: 'Circle',
};

export const ORDER_DELIVERY_VALUES = Object.keys(ORDER_DELIVERY_LABELS) as [
  OrderDeliveryPreference,
  ...OrderDeliveryPreference[],
];

/** Human label for a delivery preference; null/undefined stays null. */
export const formatOrderDeliveryPreference = (
  value: OrderDeliveryPreference | null | undefined
): string | null => (value ? (ORDER_DELIVERY_LABELS[value] ?? value) : null);
